import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { EyeIcon } from '@heroicons/react/24/solid'
import { InformationCircleIcon, TrashIcon, UserCircleIcon } from '@heroicons/react/24/outline'
import { EmptyValuePlaceholder } from "@/components/ui"
import { SingleLineAddressOnListing } from '@/components/Address'
import { formatDate } from '@/utils/formatters'

import { deleteDocument, documentTypes } from "./documentsSlice"

export default ({item}) => {
  const dispatch = useDispatch()
  const [ showConfirmDialog, setShowConfirmDialog ] = useState(false)

  const handleDownload = (e) => {
    e.preventDefault()
    e.stopPropagation()
    window.open(item.file.url, '_blank')
  }

  const handleDelete = (e) => {
    setShowConfirmDialog(true)
  }

  const confirmDelete = () => {
    dispatch(deleteDocument(item))
    setShowConfirmDialog(false)
  }

  const cancelDelete = () => {
    setShowConfirmDialog(false)
  }

  return (
    <tr className='hover:bg-primary-200' data-id={item.id} data-object="document">
      <td className="p-1">
        <EmptyValuePlaceholder value={item.titre} className="uppercase" />
      </td>
      <td className="p-1">
        <EmptyValuePlaceholder value={documentTypes[item.type_document]} />
      </td>
      <td className="p-1">
        { item.bien && 
          <div className='flex space-x-2 items-center p-1 hover:bg-primary-300'>
            <a 
              className='btn btn-square btn-ghost btn-xs p-1 hover:bg-primary-400'
              href={item.bien?.links?.show ? item.bien.links.show : '#'}
              title="Aller sur la fiche du bien"
            >
              <InformationCircleIcon/>
            </a>
            <SingleLineAddressOnListing data={item.bien} />
          </div>
        }
      </td>
      <td className="p-1">
        <div>
          { !item.contacts && <EmptyValuePlaceholder /> }
          { item.contacts && item.contacts?.map( (contact, index) => (
            <div className='flex space-x-2 items-center p-1 hover:bg-primary-300' key={index}>
              <a 
                className='btn btn-square btn-ghost btn-xs p-1 hover:bg-primary-400'
                href={contact.links?.show ? contact.links.show : '#'}
                title={`Aller sur la fiche de ${contact.nom_complet}`}
              >
                <UserCircleIcon/>
              </a>
              <EmptyValuePlaceholder value={contact.nom_complet} className="uppercase" />
            </div>
          ))}
        </div>
      </td>
      <td className="p-1">
        <EmptyValuePlaceholder value={formatDate(item.date_disponibilite)} />
      </td>
      <td className="p-1">
        <div className='flex'>
          { item.file && (
            <button 
              onClick={handleDownload}
              className="btn btn-sm btn-ghost btn-square p-1 hover:bg-primary-400"
              title={`Voir le document`} aria-label={`Voir le document`}
            >
              <EyeIcon/>
            </button>
          )}

          <button 
            onClick={handleDelete}
            className="btn btn-sm btn-ghost btn-square p-1 hover:bg-primary-400"
            title={`Supprimer le document`} aria-label={`Supprimer le document`}
          >
            <TrashIcon/>
          </button>
        </div>

        {showConfirmDialog && (
          <dialog open className="modal">
            <div className="modal-box">
              <h3 className="font-bold text-lg">Confirmer la suppression</h3>
              <p className="py-4">Êtes-vous sûr de vouloir supprimer ce document ?</p>
              <p className="py-4 text-center">{ item.titre }</p>
              <div className="modal-action">
                <button onClick={confirmDelete} className="btn btn-secondary">Supprimer</button>
                <button onClick={cancelDelete} className="btn btn-outline">Annuler</button>
              </div>
            </div>
          </dialog>
        )}
      </td>
    </tr>
  )
}